/* src/app/components/batch-process-manager/batch-process-view.component.css */
.divStyle {
  width: 50%;
  text-align: center;
  margin: 0 auto;
  background: var(--navy-600);
  border: 0px solid var(--border-strong);
  padding: 10px;
  box-shadow: 0 4px 8px 4px rgba(0, 0, 0, 0.2), 0 6px 20px 4px rgba(0, 0, 0, 0.19);
  border-radius: 4px;
}
.labelStyle {
  font-size: 16px;
  color: var(--bg-surface);
}
.spanStyle {
  padding: 5px 5px 5px 5px;
  color: var(--bg-surface);
}
.center {
  position: fixed;
  top: 45%;
  left: 47%;
}
.loader {
  border: 16px solid var(--gray-100);
  border-top: 16px solid var(--navy-600);
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*# sourceMappingURL=batch-process-view.component.css.map */
